import { LoadingOverlay } from '@mantine/core';
import type { RefObject } from 'react';
import { ContentPlaceholder } from '../../../../components/content-placeholder/content-placeholder';
import { useSelectedInitiativeCompletions } from '../../../../store/process-analysis-store/process-analysis-store.hooks';
import { useAutoSelectFilters } from '../../filters/initiative-completion/initiative-completion.hooks';
import { useInitiativeCompletionData } from '../../hooks/initiative-data';
import { InitiativeCompletionLineChart } from './line-chart/line-chart';

export const InitiativeCompletion = ({ chartRef }: { chartRef: RefObject<HTMLDivElement | null> }) => {
  const selectedInitiativeCompletions = useSelectedInitiativeCompletions();
  const { isFetching, isLoading, data } = useInitiativeCompletionData();

  useAutoSelectFilters();

  if (!isFetching && (!Array.isArray(data?.initiatives) || data.initiatives.length === 0)) {
    return <ContentPlaceholder />;
  }

  if (selectedInitiativeCompletions.length === 0) {
    return <ContentPlaceholder noFiltersApplied />;
  }

  return (
    <div style={{ position: 'relative', height: '100%', width: '100%' }}>
      <LoadingOverlay visible={isLoading} overlayProps={{ blur: 2 }} style={{ zIndex: 200 }} />
      <InitiativeCompletionLineChart ref={chartRef} />
    </div>
  );
};
